// icons
import { 
  MdAccountBalance, 
  MdPayment, 
  MdAccountBalanceWallet, 
  MdAttachMoney, 
  MdHistory, 
  MdOutlineReceipt, 
  MdOutlineReceiptLong, 
  MdAccountBox, 
  MdCalculate, 
  MdPointOfSale, 
  MdBook,
  MdSwapHoriz } from "react-icons/md";

const finanzas = {
  id: 'finanzas-group',
  type: 'group',
  roles: [1, 100, 110],
  breadcrumbs: false,
  children: [
    {
      id: 'finanzas',
      title: "Finanzas",
      type: 'collapse',
      icon: MdAccountBalance,
      children: [
        {
          id: 'corte-diario',
          title: "Corte Diario",
          type: 'item',
          breadcrumbs: false,
          icon: MdCalculate,
          url: '/finanzas/corte-diario'
        },
        {
          id: 'caja-group',
          title: "Caja",
          type: 'collapse',
          icon: MdPointOfSale,
          children: [
            {
              id: 'caja-saldo',
              title: "Saldo",
              type: 'item',
              breadcrumbs: false,
              icon: MdPointOfSale,
              url: '/finanzas/caja-saldo'
            },
            {
              id: 'caja-bitacora-movimientos',
              title: "Bitácora de Movimientos",
              type: 'item',
              breadcrumbs: false,
              icon: MdSwapHoriz,
              url: '/finanzas/caja-bitacora-movimientos'
            },
          ]
        },
        {
          id: 'caja-chica-tecnicos-2',
          title: "Caja Chica",
          type: 'collapse',
          icon: MdAccountBalanceWallet,
          children: [
            {
              id: 'cortes-por-tecnico',
              title: "Cortes por Técnico",
              type: 'item',
              breadcrumbs: false,
              icon: MdOutlineReceiptLong,
              url: '/finanzas/caja-chica/cortes-por-tecnico'
            },
            {
              id: 'bitacora-cortes',
              title: "Histórico de Cortes",
              type: 'item',
              breadcrumbs: false,
              icon: MdOutlineReceipt,
              url: '/finanzas/caja-chica/bitacora-cortes'
            },
            {
              id: 'bitacora-movimientos-caja-chica',
              title: "Bitácora de Movimientos",
              type: 'item',
              breadcrumbs: false,
              icon: MdSwapHoriz,
              url: '/finanzas/bitacora-movimientos-caja-chica'
            },
          ]
        },
        {
          id: 'cuentas-por-cobrar-group',
          title: "Cuentas por cobrar",
          type: 'collapse',
          icon: MdAccountBalance,
          children: [
            {
              id: 'cxc',
              title: "Cuentas por Cobrar",
              type: 'item',
              breadcrumbs: false,
              icon: MdAccountBalance,
              url: '/finanzas/cuentas-por-cobrar/cxc'
            },
            {
              id: 'cobros-no-conciliados',
              title: "Cobros No Conciliados",
              type: 'item',
              breadcrumbs: false,
              icon: MdPayment,
              url: '/finanzas/cuentas-por-cobrar/cobros-no-conciliados'
            },
            {
              id: 'cobros-conciliados',
              title: "Cobros Conciliados",
              type: 'item',
              breadcrumbs: false,
              icon: MdPayment,
              url: '/finanzas/cuentas-por-cobrar/cobros-conciliados'
            },
            {
              id: 'agregar-cobro',
              title: "Agregar Cobro",
              type: 'item',
              breadcrumbs: false,
              icon: MdAttachMoney,
              url: '/finanzas/cuentas-por-cobrar/agregar-cobro'
            },
          ]
        },
        {
          id: 'comisiones-group',
          title: "Comisiones",
          type: 'collapse',
          icon: MdAttachMoney,
          children: [
            {
              id: 'comisiones-por-pagar-resumen',
              title: "Comisiones por Pagar",
              type: 'item',
              breadcrumbs: false,
              icon: MdAttachMoney,
              url: '/finanzas/comisiones-por-pagar'
            },
            {
              id: 'por-pagar-desglosado',
              title: "Por Pagar Desglosado",
              type: 'item',
              breadcrumbs: false,
              icon: MdHistory,
              url: '/finanzas/por-pagar-desglosado'
            },
            {
              id: 'historico-comisiones',
              title: "Histórico Comisiones",
              type: 'item',
              breadcrumbs: false,
              icon: MdHistory,
              url: '/finanzas/historico-comisiones'
            },
            {
              id: 'bitacora-pagos-comisiones',
              title: "Bitácora de pagos",
              type: 'item',
              breadcrumbs: false,
              icon: MdHistory,
              url: '/finanzas/bitacora-pagos-comisiones'
            },
          ]
        },
        
        
      ]
    }
  ]
};

export default finanzas;
